<template>
  <div>
    <!--    <calendar/>-->
    <!--    <Select :options="departments" :value="'id'" :text="'name'"/>-->
    <!--    <Input :placeholder="userNameMessage"/>-->
    <!--    <Table :items="items" :fields="tableColumns"/>-->
    <!--    <b-table striped hover :items="items" :fields="columns"></b-table>-->

    <marks-list></marks-list>
    <competency-mark-card :item="item"></competency-mark-card>
    <marks-list-second-variant></marks-list-second-variant>
    <avatars-group :items="hardSkills" :background-color="'lightblue'"></avatars-group>
    <avatars-group :items="softSkills" :background-color="'lightgreen'"></avatars-group>
  </div>
</template>

<script>
import Select from "@/components/Selects/Select";
import Input from "@/components/Inputs/Input";
import Calendar from "../components/Calendar";
import MarksList from "../components/MarksList";
import Table from "@/components/Tables/Table";
import CompetencyMarkCard from "../components/Cards/CompetencyMarkCard";
import MarksListSecondVariant from "../components/MarksListSecondVariant";
import AvatarsGroup from "@/components/Cards/AvatarsGroup";

export default {
  name: 'TestPage',
  components: {
    Select,
    Calendar,
    MarksList,
    Input,
    Table,
    CompetencyMarkCard,
    MarksListSecondVariant,
    AvatarsGroup
  },
  data() {
    return {
      backgroundColor: "red",
      item: {
        title: 'Разработка',
        mark: 5,
        description: 'Основы разработки, языки, особенности, синтаксис блаблала, все дела и другое пятое десятое'
      },
      tableColumns: [
        {key: 'age', sortable: true, label: 'Возраст'},
        {key: 'first_name', sortable: true, label: 'Имя'},
        {key: 'last_name', sortable: true, label: 'Фамилия'},
        {key: 'department', sortable: true, label: 'Департамент'},
      ],
      userNameMessage: 'Введите имя пользователя',
      columns: [
        {
          key: 'age',
          label: 'Возраст',
          sortable: true,
        },
        {
          key: 'first_name',
          label: 'Имя',
          sortable: true,
        },
        {
          key: 'last_name',
          label: 'Фамилия',
          sortable: true,
        },
        {
          key: 'department',
          label: 'Департамент',
          sortable: true,
        }
      ],
      items: [
        {age: 40, first_name: 'Андрей', last_name: 'Зайцев', department: 'Разработчики'},
        {age: 21, first_name: 'Дмитрий', last_name: 'Игнашкин', department: 'Разработчики'},
        {age: 30, first_name: 'Нина', last_name: 'Караваева', department: 'Разработчики'},
        {age: 38, first_name: 'Никита', last_name: 'Бурматов', department: 'Разработчики'}
      ],
      departments: [
        {id: 1, name: "Коммерческая служба"},
        {id: 2, name: "Производство"},
        {id: 3, name: "Разработчики"},
        {id: 4, name: "Аналитика"},
        {id: 5, name: "Внедрение"},
      ],
      treeData: {
        name: "Seven Dwarfs",
        photo: "./img/4.jpg",
        children: [{
          name: "Minnie Mouse",
          photo: "./img/1.jpg"
        },
          {
            name: "Tom Bombadil",
            photo: "./img/3.jpg",
            children: [{
              name: "No Name",
              photo: "./img/12.jpg",
              children: [{
                name: "Sleeping Beauty",
                photo: "./img/5.jpg"
              },
                {
                  name: "Michael Jackson",
                  photo: "./img/6.jpg"
                }
              ]
            },
            ]
          }]
      },


      hardSkills: [
        {id: 1, name: "Разработка", mark: 4,
          skills: [
            {id: 1, name: "JS", mark: 5},
            {id: 2, name: "PHP", mark: 4},
            {id: 3, name: "JAVA", mark: 7},
          ],
          color: "red"
        },
        {id: 2, name: "Тестирование", mark: 7, color: "green"},
        {id: 3, name: "Аналитика", mark: 10, color: "yellow"},
        {id: 4, name: "Внедрение", mark: 3, color: "blue"},
        {id: 5, name: "Продажи", mark: 5, color: "purple"},
      ],
      softSkills: [
        {id: 1, name: "AAA", mark: 4,
          skills: [
            {id: 1, name: "Сила", mark: 5},
            {id: 2, name: "Ловкость", mark: 4},
            {id: 3, name: "Интеллект", mark: 7},
          ],
          color: 'orange'
        },
        {id: 2, name: "BBB", mark: 7, color: 'blue'},
        {id: 3, name: "CCC", mark: 10, color: 'purple'},
        {id: 4, name: "DDD", mark: 3, color: 'black'},
        {id: 5, name: "EEE", mark: 5, color: 'crimson'},
      ],

    }
  }
}
</script>

<style scoped>

</style>
